import { DataGrid, esES } from '@mui/x-data-grid';
import { Box, Tooltip, styled } from '@mui/material';
import './EscoDataGrid.css'

import MenuAcciones from '../MenuAcciones/MenuAcciones';
import EscoModal from '../EscoModal/EscoModal';
import { Children, cloneElement, useRef, useState } from 'react';
//import { AuthContext } from '../../../Context/AuthContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ForwardIcon from '@mui/icons-material/Forward';
import ForceRunIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import EscoDataGridToolbar from './EscoDataGridToolbar';


function EscoDataGrid({ columns, rows, children, loading, getRowId, pEliminar, pEditar, pSetShowDelete, pSetRowSelectd, pInit, pAgregar, pNavegar, pMuestraToolbar, pHandleMore, pHandleEjec }) {

    const handleEdit = (row) => {
        setDatos(row);
        handleOpen();
    };

    const handleDelete = (row) => {

        pSetRowSelectd(row);
        pSetShowDelete(true);
    }

    
    const [puedeEliminar, setPuedeEliminar] = useState(pEliminar);
    const [puedeEditar, setPuedeEditar] = useState(pEditar);
    const [puedeNavegar, setPuedeNavegar] = useState(pNavegar);
    const [puedeEjecutar, setPuedeEjecutar] = useState(pInit);

    // Verificar si la columna "Acciones" ya existe en el array de columnas
    const accionesColumnExists = columns.some(column => column.field === 'Acciones');

    if (!accionesColumnExists) {
        columns.push({
            field: 'Acciones',
            headerName: 'Acciones',
            renderCell: (params) => (
                <div>
                    {
                        puedeEditar && <Tooltip title="Editar"><EditIcon className="MuiSvgIcon-root accions-icon" onClick={() => handleEdit(params.row)}></EditIcon></Tooltip>
                    }
                    {
                        puedeEliminar && <Tooltip title="Eliminar"><DeleteForeverIcon className="MuiSvgIcon-root accions-icon" onClick={() => handleDelete(params.row)}></DeleteForeverIcon></Tooltip>
                    }
                    {
                        puedeNavegar && <Tooltip title="Más"><ForwardIcon className="MuiSvgIcon-root accions-icon" onClick={() => pHandleMore(params.row)}></ForwardIcon></Tooltip>
                    }
                    
                    {
                        puedeEjecutar && <Tooltip title="Ejecutar"><ForceRunIcon className="MuiSvgIcon-root accions-icon" onClick={() => pHandleEjec(params.row)}></ForceRunIcon></Tooltip>
                    }
                </div>
            ),
        });
    }

    columns.map((c) => { return c.headerClassName = 'EscoGridData-header' });

    const StyledDataGrid = styled(DataGrid)((theme) => ({
        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "white",
        },
        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "white"
        },
        "& .MuiDataGrid-columnSeparator": {
            display: 'none',
        },

        "& .MuiDataGrid-cell--editable": {
            backgroundColor: 'rgba(197, 255, 183, 0.40)',//'rgb(217 243 190)',
        },
    }));

    //const apiRef = useGridApiRef();

    const handlerAccion = (accion) => {
        setDatos({});
        handleOpen();
    }
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    const [datos, setDatos] = useState({});



    return (
        <>

            <Box
                sx={{
                    height: 600,
                    width: '100%',
                }}
            >
                {pAgregar !== false && <MenuAcciones handlerAccion={handlerAccion} />}

                <StyledDataGrid
                    sx={{ m: 2 }}
                    rows={rows}
                    columns={columns}
                    autoHeight={true}
                    disableColumnResize={false}
                    //getRowHeight={() => 'auto'}
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}

                    //isCellEditable={(params) => { const row = params.id; console.log(apiRef); return true }}

                    slots={{
                        toolbar:  pMuestraToolbar&&EscoDataGridToolbar /*null*/ /*GridToolbar*/,
                    }}

                    isCellEditable={(params) => true}

                    loading={loading}

                    getRowId={getRowId}

                    density='compact'

                />
                <EscoModal isOpen={open} handleOpen={handleOpen} handleClose={handleClose} >

                    {/* a los children se les pasa la funcion para cerrar el modal */}
                    {Children.map(children, child => {
                        return cloneElement(child, { handleClose: handleClose, dataEdit: datos }, null)
                    })}

                </EscoModal>

            </Box>

        </>

    );
}

export default EscoDataGrid;